import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { apiUrl } from "./../../config";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Cookie } from "ng2-cookies/ng2-cookies";

@Injectable()
export class AddBandsService {
  cookies: Object;
  options: RequestOptions;
  constructor(private http: Http) {}

  getServiceProviderType() {
    var url = apiUrl + "/serviceProviderType";
    // const url = "http://localhost/deutz1/public/serviceProviderType";

    return this.http.get(url).map(res => {
      const data = res.json();
      // console.log(data);
      return data;
    });
  }

  deleteBrands(id: any) {
    //const url = "http://localhost/deutz1/public/deletebrands";
    var url = apiUrl + "/deletebrands";
    const body = "data=" + id;

    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const options = new RequestOptions({
      headers: headers
    });
    return this.http.post(url, body, options).map(res => {
      const data = res.json();
      return data;
    });
  }

  editbrands(data: any) {
    //const url = "http://localhost/deutz1/public/saveeditbrands";
    var url = apiUrl + "/saveeditbrands";

    //const obj = { name: name, service: servicetype,id:id };
    const body = "data=" + JSON.stringify(data);

    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const options = new RequestOptions({
      headers: headers
    });
    return this.http.post(url, body, options).map(res => {
      const data = res.json();
      return data;
    });
  }

  savebrands(data: any) {
    //const url = "http://localhost/deutz1/public/addbrands";
    var url = apiUrl + "/addbrands";

    //const obj = { name: name, service: servicetype,id:id };
    const body = "data=" + btoa(JSON.stringify(data));

    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const options = new RequestOptions({
      headers: headers
    });
    return this.http.post(url, body, options).map(res => {
      const data = res.json();
      return data;
    });
  }

  getbrands() {
    var url = apiUrl + "/allbrands";
    //const url = "http://localhost/deutz1/public/allbrands";
    return this.http.get(url).map(res => {
      const data = res.json();
      console.log(data);
      return data;
    });
  }

  getallbrands() {
    var url = apiUrl + "/getallbrands";
    //const url = "http://localhost/deutz1/public/getallbrands";
    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  editdetails(id: any): Observable<any> {
    var url = apiUrl + "/editdetails";
    //var url = 'http://localhost/deutz1/public/editdetails';
    const body = "data=" + id;
    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const options = new RequestOptions({
      headers: headers
    });

    return this.http.post(url, body, options).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_services/brand/add-bands.service.ts